export class Regex {
  static timeInputRegex = new RegExp('^([0-1]?[0-9]|2[0-3])([:\\.-\\s])?([0-5][0-9])(:[0-5][0-9])?$');
  static numberRegex = new RegExp('^[0-9]*$');
  static decimalNumberRegex = new RegExp('^([0-9][0-9]*)(\\.)?([0-9]*)$');
}
